<template>
  <div>
          <div style="width: 500px; margin:70px auto 0">

              <div class="photo">
                  <img class="logo" :src="imgdata" >
                  <Upload
                          :format="['jpg','jpeg','png']"
                          :on-success="handleSuccess"
                          :action="actionImgUrl">
                      <p>修改头像</p>
                  </Upload>
              </div>
              <Form ref="formValidate"  :label-width="80" style="padding-top: 50px">
                  <FormItem label="公司名字:">
                      <Input  v-model="formValidate.name"  maxlength="20" placeholder="店铺名字必填"></Input>
                  </FormItem>
                  <FormItem label="联系方式:">
                      <Input  v-model="formValidate.tel"  maxlength="20"  placeholder="联系方式必填"></Input>
                  </FormItem>
                  <FormItem label="公司地址:">
                      <Input  v-model="formValidate.address"  maxlength="20"  placeholder="公司地址必填" ></Input>
                  </FormItem>
                  <FormItem label="详细地址:">
                      <Input  v-model="formValidate.addressDel"  maxlength="40" placeholder="详细地址必填" disabled></Input>
                  </FormItem>
                  <FormItem label="专属客服:">
                      <Input  v-model="formValidate.principal"  :disabled="isfalg"></Input>
                  </FormItem>
                  <FormItem label="客服姓名:">
                      <Input  v-model="formValidate.kfName"    disabled></Input>
                  </FormItem>
                  <FormItem>
                      <Button   type="primary" @click="saveMsg()">保存</Button>
                  </FormItem>
              </Form>
          </div>

  </div>
</template>
<script>
  export default {
    components: {},
    data () {
      return {
          cid:"",
          actionImgUrl:this.ACTIONIMGURL,
          formValidate: {
              name: '',
              tel: '',
              addressDel: '',
              address: '',
              kf: '',
              kfName: '',
              imgurl:''
          },
          isfalg:true,
          imgdata:''

      }
    },

    mounted: function() {
      //DOM更新完后再请求数据
      this.$nextTick(function() {

      });
    },
    created: function() {
      //DOM更新完之前请求数据
        let data= JSON.parse(localStorage.getItem('adminUser'))
        this.cid=data.cid
        this.getConpanyMsg(data.cid)
        this.getPhoto()
    },
    methods: {
        getPhoto(){
            this.$Api.getCompanyId({
                id: JSON.parse(localStorage.getItem("adminUser")).cid
            }).then(res => {
                if (res.code == 200) {
                    if(res.data.imgurl==''){
                        this.imgdata= require('../../assets/img/logo.png')
                    }else {
                        this.imgdata ="https://tangyingkeji.oss-cn-beijing.aliyuncs.com/tangyingkeji.oss-cn-beijing.aliyuncs.com" + res.data.imgurl;
                    }

                } else {
                    this.$Message.warning(res.msg);
                }
            });
        },
        handleSuccess(file,res){
            if(file.code==200){
                this.formValidate.imgurl = file.data.src
                this.imgdata  ="https://tangyingkeji.oss-cn-beijing.aliyuncs.com/tangyingkeji.oss-cn-beijing.aliyuncs.com" + file.data.src

            }
        },
        getConpanyMsg(id){
            let data = {
                id:id
            };
            this.$Api.getCompanyId(data).then(res => {
                if(res.code==200){
                    this.formValidate.name=res.data.name
                    this.formValidate.tel=res.data.phone
                    this.formValidate.address=res.data.address
                    this.formValidate.addressDel=res.data.address.split('区')[1]
                    this.formValidate.kfName=res.data.principalName
                    this.formValidate.principal=res.data.cellPhone
                    /*if(res.data.cellPhone==null){
                       this.isfalg=false
                    }else {
                        this.isfalg=true
                    }*/
                }else {
                    this.$Message.warning(res.msg);
                }
            });
        },
        //更新
        saveMsg(){
            let data = {
                id: this.cid,
                name:this.formValidate.name,
                phone:this.formValidate.tel,
                imgurl:this.formValidate.imgurl,
                address:this.formValidate.address+this.formValidate.addressDel,
                email:'',
                principal:'',
                principalName:this.formValidate.kfName,
                cellPhone:this.formValidate.kf,
            };
            if(this.formValidate.name==''){
                this.$Message.info('店铺名字不能为空');
                return
            }
            if(this.formValidate.tel==''){
                this.$Message.info('联系方式不能为空');
                return
            }
            if(this.formValidate.address==''){
                this.$Message.info('公司地址不能为空');
                return
            }
            this.$Api.updateCompany(data).then(res => {
                if(res.code==200){
                    this.getConpanyMsg(this.cid)
                    this.$Message.success('修改成功！');
                    window.location.reload(true);
                }else {
                    this.$Message.warning(res.msg);
                }
            });
        },

    }
  }
</script>


<style  lang="scss" scoped>
.server-title{
    display: inline-block;
    text-align: center;width: 88%
}
.photo{
    width: 100px;
    height: 100px;
    border-radius: 50%;
    cursor: pointer;
    margin: auto;
    overflow: hidden;
    position: relative;
    p{
        position: absolute;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        color: #ff9800;
        line-height: 100px;
        text-align: center;
        background: rgba(0,0,0,0.7);
        display: none;
    }
}
.photo:hover {
    p{
        display: block;
    }

}
.logo{
    width: 100%;
    height: 100%;

}
.ivu-form-item{
    margin-bottom: 10px;
}
</style>